import React from 'react';
import { observer } from 'mobx-react-lite';
import { Window, WindowHeader } from '../overlays';
import { Button } from '../input';
import { LiveNotStreamingWindowState } from './liveNotStreamingWindowState';

type Props = {
  model: LiveNotStreamingWindowState;
  visible?: boolean;
};

export const LiveNotStreamingWindow = observer((props: Props) => {
  const { model } = props;

  return (
    <Window
      model={model.window}
      visible={props.visible}
      isLoading={model.isLoading}>
      <WindowHeader model={model.window} title="Feed not streaming" />

      <hr />

      <div className="window-content">
        <p className="p-bold">Have you set up this backup stream in your livestream host?</p>
        <p>Check that your stream has started.</p>
      </div>

      <hr />

      <footer className="window-footer">
        <div className="btn-group right">
          <Button
            className="primary btn-outline medium"
            label="Cancel"
            onClick={() => model.close()}
          />
          <Button
            className="primary medium"
            label="Confirm"
            onClick={() => model.submit()}
          />
        </div>
      </footer>
    </Window>
  );
});
